import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/service/coord-helper.ts' );

import { Injectable } from '@angular/core';
import { Constants } from '../commons/Constants';
import { Transform } from '4d-mapper';

import LatLon, { Dms } from 'geodesy/latlon-ellipsoidal-vincenty.js';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';
import { MeasurementHelperService } from './measurement-helper.service';


const clustering = require('density-clustering');
const Cesium = (<any>window).Cesium

LatLon.prototype.boundingTravel = function ( distance:number = 100, steps:number = 45) {
  let res =[];
  for ( let n=0; n<360; n+=steps ) {
    let c = this.destinationPoint(distance, n);
    res.push( c );
    // console.log ( '!', n, c );
  }
  return res;
}

LatLon.prototype.boundingBox = function ( distance:number = 100 ) {
    return [
        this.destinationPoint(distance, -90)._lon,
        this.destinationPoint(distance, 180)._lat,
        this.destinationPoint(distance, 90)._lon,
        this.destinationPoint(distance, 0)._lat,
    ];

}
// an attempt to create unified non-platform/framework specific classes for all coordinates
// future todo: look into either turf.js, or maybe better geodesy-library

export class LatLong {

  // generic CSV coordinate import column indexes
  static uid = 0;
  static longitude = 1;
  static latitude = 2;
  static height = 3;
  static longitude_accuracy = 4;
  static latitude_accuracy = 5;
  static height_accuracy = 6;

  static longitudeLabel = "Longitude";
  static latitudeLabel = "Latitude";
  static eastingLabel = "Easting";
  static northingLabel = "Northing";

  // let's check a number of variations, that way we can be compatible with lots of other coord objects
  static alsoCheckThese:any = [ ['lat', 'latitude'], ['long', 'longitude', 'lon', 'lo', 'lng'], ['height', 'h', 'hgt', 'altitude' ] ];

  static fromObject = 'UNKNOWN';
  static fromImage = 'IMAGE';
  static fromExif = 'EXIF';
  static fromCSV = 'CSV_FILE';

}

export class CoordZone {

  area:any = null;

  allProperties:string[] = ['longitude','latitude','height'];

  constructor( config:any = null ) {
    this.init(config);
  }

  init ( config:any = null ) {
    this.area = {
      longitude:  { min: 0, max: 0, all: [] },
      latitude:   { min: 0, max: 0, all: [] },
      height:     { min: 0, max: 0, all: [] },
      cartesianArray: [],
      cartographicArray: [],
      corners: {
        all: [],
        samplingDistance: 0,
        samplingDistanceMin:0.3,
        samplingDistanceMax:5,
        width: 0,
        length: 0
      },
      grid: {
        all: [],
        allCartographic: [],
        samplingDistance: 0,
        x: 0,
        y: 0
      }
    };
    if ( config ) {
      if ( config.cartesianArray ) {
        this.area.cartesianArray = config.cartesianArray;
        if ( !config.cartographicArray ) {
          this.convertCartesianToCartographic();
        }
      }
      if ( config.cartographicArray ) {
        this.area.cartographicArray = config.cartographicArray;
        if ( !config.cartesianArray ) {
          // this.convertCartographicToCartesian();
        }
      }
    }
  }

  convertCartesianToCartographic() {
    if ( this.area.cartesianArray && this.area.cartesianArray.length ) {
      this.area.cartographicArray = [];
      this.resetAll();
      this.area.cartesianArray.forEach ( c => {
        const cc = Cesium.Cartographic.fromCartesian(c);
        this.area.cartographicArray.push(cc);
        this.minMaxLog(cc);
      });
      this.createCorners();
      this.analyzeCorners();
      this.createGrid();
    }
  }

  minMaxLog(cc:any) {
    this.allProperties.forEach ( key => {
      const value = cc[key];
      const section = this.area[key];
      if ( value < section.min ) {
        // console.log('min',value,section.min);
        section.min = value;
      }
      if ( value > section.max ) {
        // console.log('max',value,section.max);
        section.max = value;
      }
      section.all.push(value);
    });
  }

  createCorners() {
    this.area.corners.all = [];
    this.area.corners.all.push( new Cesium.Cartographic( this.area.longitude.min, this.area.latitude.min, this.area.height.min ) );
    this.area.corners.all.push( new Cesium.Cartographic( this.area.longitude.max, this.area.latitude.min, this.area.height.min ) );
    this.area.corners.all.push( new Cesium.Cartographic( this.area.longitude.min, this.area.latitude.max, this.area.height.min ) );
    this.area.corners.all.push( new Cesium.Cartographic( this.area.longitude.max, this.area.latitude.max, this.area.height.min ) );

    var lc  = new Cesium.Cartesian3.fromRadians( this.area.longitude.min, this.area.latitude.min, this.area.height.min );
    var lcr = new Cesium.Cartesian3.fromRadians( this.area.longitude.max, this.area.latitude.min, this.area.height.min );
    var lcu = new Cesium.Cartesian3.fromRadians( this.area.longitude.min, this.area.latitude.max, this.area.height.min );

    this.area.corners.width = Cesium.Cartesian3.distance(lc, lcr);
    this.area.corners.length = Cesium.Cartesian3.distance(lc, lcu);

    // console.log('CORNERING', lc, lcr, lcu, this.area.corners, Cesium.Cartesian3.distance(lc, lcr) );

    this.area.corners.samplingDistance = 1.5;
  }

  analyzeCorners() {

    if ( this.area.grid.samplingDistance < 0.001 ) {
      this.area.corners.samplingDistanceMin = 0.2;
      this.area.corners.samplingDistance = 1.5;
      this.area.corners.samplingDistanceMax = 5;
    }

    if ( this.area.corners.width < 3 ) {
      this.area.corners.samplingDistanceMin = 0.005;
      this.area.corners.samplingDistance = 0.2;
      this.area.corners.samplingDistanceMax = 1;
    } else

    if ( this.area.corners.width < 5 ) {
      this.area.corners.samplingDistanceMin = 0.1;
      this.area.corners.samplingDistance = 0.3;
      this.area.corners.samplingDistanceMax = 2;
    } else

    if ( this.area.corners.width < 10 ) {
      this.area.corners.samplingDistanceMin = 0.3;
      this.area.corners.samplingDistance = 1.5;
      this.area.corners.samplingDistanceMax = 5;
    } else

    if ( this.area.corners.width < 100 && this.area.corners.length < 100 ) {
      this.area.corners.samplingDistanceMin = 0.2;
      this.area.corners.samplingDistance = 2;
      this.area.corners.samplingDistanceMax = 6;
    } else

    if ( this.area.corners.width < 200 && this.area.corners.length < 200 ) {
      this.area.corners.samplingDistanceMin = 0.6;
      this.area.corners.samplingDistance = 4;
      this.area.corners.samplingDistanceMax = 10;
    } else

    if ( this.area.corners.width < 300 && this.area.corners.length < 400 ) {
      this.area.corners.samplingDistanceMin = 2;
      this.area.corners.samplingDistance = 8;
      this.area.corners.samplingDistanceMax = 20;
    } else

    if ( this.area.corners.width < 1000 && this.area.corners.length < 800 ) {
      this.area.corners.samplingDistanceMin = 3;
      this.area.corners.samplingDistance = 16;
      this.area.corners.samplingDistanceMax = 30;

    } else {

      this.area.corners.samplingDistanceMin = 8;
      this.area.corners.samplingDistance = 20;
      this.area.corners.samplingDistanceMax = 50;

    }
  }

  createGrid() {

    this.area.grid.x = Math.floor ( this.area.corners.width / this.area.corners.samplingDistance );
    this.area.grid.y = Math.floor ( this.area.corners.length / this.area.corners.samplingDistance );

    this.area.grid.all = [];
    this.area.grid.allCartographic = [];

    for (var y = 0; y < this.area.grid.y; ++y) {
      for (var x = 0; x < this.area.grid.x; ++x) {

        var X = Cesium.Math.lerp(this.area.longitude.min, this.area.longitude.max, x / (this.area.grid.x - 1));
        var Y = Cesium.Math.lerp(this.area.latitude.min, this.area.latitude.max, y / (this.area.grid.y - 1));

        var positionCartographic = new Cesium.Cartographic(X, Y, this.area.height.max + 10 );

        if (this.pointInsidePolygon( positionCartographic )) {
          this.area.grid.all.push( new Cesium.Cartesian3.fromRadians( X, Y, this.area.height.max + 10 ) );
          this.area.grid.allCartographic.push(positionCartographic);
        }
      }
    }

    // console.log('GRDDING', y, x, this.area );

    // calculate distance from the first two grid positions
    var gdLcr = new Cesium.Cartesian2.fromCartesian3(this.area.grid.all[0]);
    var gdLcu = new Cesium.Cartesian2.fromCartesian3(this.area.grid.all[1]);

    this.area.grid.samplingDistance = Cesium.Cartesian2.distance(gdLcr, gdLcu);

  }

  resetAll() {
    this.allProperties.forEach ( key => {
      this.area[key].min = 9999;
      this.area[key].max = -9999;
      this.area[key].all = [];
    });
  }
  
  pointInsidePolygon(point) {
    // ray-casting algorithm http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
    var x = point.longitude, y = point.latitude;

    const vX = this.area.longitude.all;
    const vY = this.area.latitude.all;
    
    var inside = false;
    for (var i = 0, j = vX.length - 1; i < vX.length; j = i++) {
      var xi = vX[i], yi = vY[i];
      var xj = vX[j], yj = vY[j];

      var intersect = ((yi >= y) != (yj >= y))
        && (x <= (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) {
        inside = !inside;
      }
    }

    return inside;
  }

}

export class CoordGeodetic {

  static cloneableProperties = ['id','name','transformId','transform','selected','lat','long','height','x','y','z','timestamp','source','isProjected','isConverted','epsgCode'];

  // some coordinates can be selected (for jobs, for pleasure, for strife...)
  selected:boolean = false;

  // base geodesic coords
  lat:number = null;
  long:number = null;
  height:number = null;

  // possible cartesian version
  x:number = null;
  y:number = null;
  z:number = null;

  // some coordinates have an ID (for some nefarious reason, I'm sure)
  id:any = null;

  // some coordinates have names
  name:string = null;

  // if it has a type
  type:any = null;

  // if this coord is linked to a Transform
  transformId:number = null;

  // or a direct reference object
  transform:any = null;

  // timestamp, if any (any:mostly for sorting)
  timestamp:any = null;

  // generic metadata

  // converted from another coordinate system?
  source:string = LatLong.fromImage;
  isProjected:boolean = false;
  isConverted:string = null;
  isConvertedHere:string = null;
  isSwapped:boolean = false;
  epsgCode:string = '4326';

  projected_x:number = null;
  projected_y:number = null;

  // convert any typed object to a simple plain old object (x,y,z and long,lat,height support)
  static toPlain ( obj:any ) {
    if ( obj['x'] ) {
      return { x:obj['x'], y:obj['y'], z:obj['z'] };
    } else if ( obj['long'] ) {
      return { lat:obj['lat'], long:obj['long'], height:obj['height'] };
    } else if ( obj['longitude'] ) {
      return { latitude:obj['latitude'], longitude:obj['longitude'], height:obj['height'] };
    }
    return { error: 'Not sure what this coord object is ...'};
  }

  constructor ( convert:any = null, fromRadians:boolean = false ) {
    if ( convert ) {
      this.fromObject ( convert, fromRadians );
    }
  }

  clone ( adjustments:any = {} ) {
    let me = this;
    let ret = new CoordGeodetic();
    CoordGeodetic.cloneableProperties.forEach( v => {
      ret[v] = adjustments[v] ? adjustments[v] : me[v];
    });
    return ret;
  }

  hasCoord() : boolean {
    if ( this.lat && this.long ) {
      return true;
    }
    return false;
  }

  hasCartesianCoord() : boolean {
    if ( this.x && this.y ) {
      return true;
    }
    return false;
  }

  getCartesian() {
    return { x:this.x, y:this.y, z:this.z };
  }

  updateCartesian ( cart:any ) {
    if ( cart && cart.x && cart.y ) {
      this.x = cart.x;
      this.y = cart.y;
      if ( cart.z ) {
        this.z = cart.z;
      }
    }
    return this;
  }

  // return a Cesium cartographic 
  toCesiumCartographic() {
    return new Cesium.Cartographic( this.long, this.lat, this.height );
  }

  // return a Cesium cartesian
  toCesiumCartesian() {
    return new Cesium.Cartesian3( this.x, this.y, this.z );
  }

  fromTransform( t:Transform, alsoCheckSub:string = null ) {
    if ( !t ) {
      return;
    }
    if ( t.llng ) {
      this.long = t.llng;
    } else if ( t.ulng ) {
      this.long = t.ulng;
    }
    if ( t.llat ) {
      this.lat = t.llat;
    } else if ( t.ulat ) {
      this.lat = t.ulat;
    }
    if ( t.lheight ) {
      this.height = t.lheight;
    } else if ( t.uheight ) {
      this.height = t.uheight;
    }
    if ( t.dateMade ) {
      this.timestamp = t.dateMade;
    }
    if ( alsoCheckSub && t[alsoCheckSub] ) {
      this.fromObject ( t[alsoCheckSub] );
      this.source = LatLong.fromExif;
    }
  }

  fromObject ( o:any, fromRadians:boolean = false ) {
    if ( !o ) {
      return;
    }

    if ( o.x && o.y ) {
      // this.updateCartesian(o);
      o = Cesium.Cartographic.fromCartesian ( o );
        fromRadians = true;
    }

    // process any latitudes
    LatLong.alsoCheckThese[0].forEach(element => {
      if ( o[element] ) {
        this.lat = fromRadians ? this.convertFromRadians ( o[element] ) : o[element];
        return;
      }
    });
    // process any longitudes
    LatLong.alsoCheckThese[1].forEach(element => {
      if ( o[element] ) {
        this.long = fromRadians ? this.convertFromRadians ( o[element] ) : o[element];
        return;
      }
    });
    // process any heights
    LatLong.alsoCheckThese[2].forEach(element => {
      if ( o[element] ) {
        this.height = o[element];
        return;
      }
    });
  }

  convertFromRadians ( radians:number ) {
    return radians * 180 / Math.PI;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CoordHelperService implements XsIdentityInterface {

  __ID = null;

  debug:boolean = Constants.debug_off;
  debugPrimary:string = Constants._orange;
  debugSecondary:string = Constants._black;

  constructor ( public measureHelper: MeasurementHelperService ) {
    DEBUG.log ( '/service/coord-helper.service.ts' );
    this.__ID = XsIdentityInterface.__init(this);
  }

  // wrapper for now

  toCartesian ( geodetic:CoordGeodetic ) {
    let geo = null;
    try {
      geo = LatLon.parse ( geodetic.lat, geodetic.long, geodetic.height ? geodetic.height : 1 );
      // console.log ('+++++ coordH:toCart', geo );
      let cart = geo.toCartesian();
      // console.log ('+++++ coordH:toCart ret', cart );
      return cart;
    } catch (error) {
      console.log ( 'toCartesian() error', geodetic, geo );
    } 
    return null;
  }

  toCartesians ( geodetics:CoordGeodetic[] ) {
    let ret = [];
    geodetics.forEach ( g => {
      if ( g.hasCoord() ) {
        if ( g.hasCartesianCoord() ) {
          ret.push ( g.getCartesian() );
        } else {
          ret.push ( g.updateCartesian ( this.toCartesian ( g ) ) );
        }
      }
    });
    return ret;
  }

  fromCartesian ( c:any ) {
    return new CoordGeodetic(c);
  }

  fromCartesians ( a:any[] ) {
    let ret = [];
    a.forEach ( p => {
      ret.push( this.fromCartesian(p));
    });
    return ret;
  }

  updateCartesian ( geodetic:CoordGeodetic ) {
    // console.log ('+++++ coordH:updateCart', geodesic, geodesic.hasCoord() );
    if ( geodetic.hasCoord() ) {
      geodetic.updateCartesian ( this.toCartesian ( geodetic ) );
    }
  }

  updateCartesians ( geodetics:CoordGeodetic[] ) {
    geodetics.forEach ( g => {
      if ( g.hasCoord() ) {
        g.updateCartesian ( this.toCartesian ( g ) )
      }
    });
  }

  toLinearGeodesicArray ( geodesics:CoordGeodetic[], ignoreHeight:boolean = false ) {
    let ret = [];
    geodesics.forEach ( g => {
      if ( g.hasCoord() ) {
        ret.push(g.long, g.lat, ignoreHeight ? 1 : g.height );
      }
    });
    return ret;
  }

  worldFromCartesian ( c:any ) {
    if ( !c ) {
      return null;
    }
    let ret = new Cesium.Cartographic.fromCartesian( c );
    ret.longitude = ret.longitude * 180 / Math.PI;
    ret.latitude = ret.latitude * 180 / Math.PI;
    return ret;
  }

  worldToRadians ( c:any ) {
    return new Cesium.Cartographic.fromDegrees( c.longitude, c.latitude, c.height );
  }

  worldToCartesian ( c:any ) {
    return new Cesium.Cartesian3.fromDegrees( c.longitude, c.latitude, c.height );
  }

  cloneCoords ( geodesics:CoordGeodetic[], adjustments:any = {} ) : CoordGeodetic[] {
    let ret:CoordGeodetic[] = [];
    geodesics.forEach ( g => {
      if ( g.hasCoord() ) {
        ret.push( g.clone(adjustments) );
      }
    });
    return ret;
  }

  updateCesiumCartesianHeight ( cart:any, height:number = 1, heightAppend:boolean = false ) {
    let coord = new CoordGeodetic(cart);
    if ( heightAppend ) {
      coord.height = coord.height + height;
    } else {
      coord.height = height;
    }
    return this.toCartesian ( coord );
  }

  updateCesiumCartesianHeights ( cart:any[], height:number = 1, heightAppend:boolean = false ) {
    let ret = [];
    if ( cart.length ) {
      cart.forEach( c => ret.push ( this.updateCesiumCartesianHeight ( c, height, heightAppend ) ) );
    }
    return ret;
  }

  getCoordsFromTransforms ( transforms:Transform[] = null ) {

    let res = [];

    if ( transforms ) {

      transforms.forEach ( t => {
        if ( t ) {
  
          let latLong:CoordGeodetic = null;

          latLong = new CoordGeodetic();
          latLong.fromTransform(t, 'exif_loc' );

          if ( latLong && latLong.hasCoord() ) {

            // make sure we've got a reference to what image it is
            latLong.transformId = t.id;

            latLong.name = t['ds_name'];
  
            // create a cartesian version
            let cart = this.toCartesian ( latLong );
  
            // update the coordinate with it
            latLong.updateCartesian( cart );

            res.push ( latLong );
          }
        }
      });
    }
    
    return res;
  }

  getCoordsFromItem ( item: any ) {

    let coords = { latitude: null, longitude: null, height: null };

    if (  item['firstTransformCoords'] ) {
      coords = item['firstTransformCoords'];
    }

    if ( item['__cameras'] && item['__cameras'][0] ) {
      const carto  = Cesium.Ellipsoid.WGS84.cartesianToCartographic( item['__cameras'][0]['data']['position'] );
      if ( carto && carto['longitude'] ) {
        coords.longitude = Cesium.Math.toDegrees(carto.longitude);
        coords.latitude = Cesium.Math.toDegrees(carto.latitude);
        coords.height = carto.height;
      }
    }

    if ( item.props['cameraPosition'] && item.props['cameraPosition']['position'] ) {
      const carto  = Cesium.Ellipsoid.WGS84.cartesianToCartographic( item.props['cameraPosition']['position'] );
      if ( carto && carto['longitude'] ) {
        coords.longitude = Cesium.Math.toDegrees(carto.longitude);
        coords.latitude = Cesium.Math.toDegrees(carto.latitude);
      }
    }

    if ( item['cameraPosition'] ) {
      if ( item['cameraPosition']['longitude'] ) {
        coords = item['cameraPosition'];
      } else {
        const carto  = Cesium.Ellipsoid.WGS84.cartesianToCartographic( item['cameraPosition'] );
        if ( carto && carto['longitude'] ) {
          coords.longitude = Cesium.Math.toDegrees(carto.longitude);
          coords.latitude = Cesium.Math.toDegrees(carto.latitude);
        }
      }
    }

    if ( item.llng && item.llat ) {
      coords.longitude = item.llng;
      coords.latitude = item.llat;
      coords.height = item.lheight;
    }

    return coords;
  }

  getCoordFromCesiumObject ( object:any ) {
    return new Promise(resolve => {
      this.getCoordsFromCesiumObject(object).then( coords => {

        if ( coords ) {
          if ( coords['x'] ) {
            // cartesian coord
            resolve(coords);
          } else
        
          if ( coords && coords['length'] ) {
            // array of cartesians, convert to a center point
              resolve(Cesium.BoundingSphere.fromPoints( coords ).center);
          } else {
  
            // anything else is an error (although we can write a geodesic / cartographic => cartesian(s) converter here)
            resolve(null);
          }
        } else {
          resolve(null);
        }

      });
    });
  }

  getCoordsFromCesiumObject ( object:any ) {

    return new Promise(resolve => {

      if ( !object ) {
        resolve(null);
      }

      let me = this;
      
      if ( object.polyline ) {
          // console.log ( 'polyline');
          resolve(object.polyline.positions._value);
      } else if ( object.wall ) {
          // console.log ( 'wall');
          resolve(object.wall.positions._value);
      } else if ( object.polygon ) {
          // console.log ( 'polygon');
          resolve(object.polygon.hierarchy.positions._value);
      } else if ( object.position ) {
        // console.log ( 'position',object.position._value);
        resolve([object.position._value]);
    } else if ( object.positions ) {
      // console.log ( 'positions');
      resolve(object.positions._value);
  } else if ( object.boundingSphere ) {
          // console.log ( 'boundingSphere');
          resolve([object.boundingSphere.center]);
      } else if ( object.imageryProvider ) {
        object.getViewableRectangle().then(function (rectangle) {

            let rect = Cesium.Rectangle.center(rectangle);
            let co = new CoordGeodetic ( rect, true );

            // force at least some height in there for your viewing pleasure
            co.height = 100;

            me.updateCartesian(co);
            resolve([co]);
        });
      } else {
        resolve(null);
      }
    });
  }


  getBoundingCoords ( geodetic:CoordGeodetic, distance:number = 140, circleDivisions:number = 7 ) {

    let height = geodetic.height;

    if ( !geodetic.hasCoord() ) {
      return [null];
    }

    let geo = LatLon.parse ( geodetic.lat, geodetic.long, 0 ); // height=0, otherwise we'll get an range error
    let box = geo.boundingTravel ( distance, 361 / circleDivisions );

    let ret = [];
    box.forEach ( c => {
      ret.push ( new CoordGeodetic ({ long: c.lon, lat: c.lat, height: height }) );
    });

    // if ( this.debug ) { console.log ( '%c coord.service %c getBoundingCoords()', this.debugPrimary, this.debugSecondary, points, result ); }

    return ret;
  }

  getBoundingBox ( geodesic:CoordGeodetic, distance:number = 90 ) {
    return this.getBoundingCoords ( geodesic, distance, 4 );
  }

  getMax ( coords:CoordGeodetic[], what:string ) {
    return Math.max.apply(Math, coords.map(function(o) { return o[what]; }))
  }

  getMin ( coords:CoordGeodetic[], what:string ) {
    return Math.min.apply(Math, coords.map(function(o) { return o[what]; }))
  }

  // return format is { west:0, south:0, east:0, north:0 }
  getRectangle ( coords:CoordGeodetic[] ) {
    return { west:this.getMin(coords,'long'), south:this.getMin(coords,'lat'), east:this.getMax(coords,'long'), north:this.getMax(coords,'lat') };
  }

  getMiddlePoint( p1:any, p2:any ) {
	
    //-- Longitude difference
    const dLng = this.toRad( p2.long - p1.long );

    //-- Convert to radians
    let p1lat = this.toRad ( p1.lat );
    let p2lat = this.toRad ( p2.lat );
    let p1lng = this.toRad ( p1.long );

    var bX = Math.cos(p2lat) * Math.cos(dLng);
    var bY = Math.cos(p2lat) * Math.sin(dLng);
    var lat3 = Math.atan2(Math.sin(p1lat) + Math.sin(p2lat), Math.sqrt((Math.cos(p1lat) + bX) * (Math.cos(p1lat) + bX) + bY * bY));
    var lng3 = p1lng + Math.atan2(bY, Math.cos(p1lat) + bX);

    return new CoordGeodetic ({ lat: this.toDeg(lat3), long: this.toDeg(lng3) });
  }

  toRad ( d:number ) {
    return d * Math.PI / 180;
  }

  toDeg ( d:number ) {
    return d * (180 / Math.PI);
  }

  createHullCartesian3 ( points:any[] = [] ) {
    return convexhull.makeHullCartesian3(points);
  }

  createHullPolygon ( points:CoordGeodetic[] = [], returnCartesian:boolean = false ) {

    // find convex hull polygon from points
    let result = convexhull.makeHull(points);

    // make sure we create a closed loop
    if ( result.length > 0 ) {
      const beginning = new CoordGeodetic ( { lat: result[0].lat + 0.00001, long: result[0].long + 0.00001, height: result[0].height } ) ;
      result.push ( beginning );
      // console.log ( "!!!!!!", result);
    }

    // if ( this.debug ) { console.log ( '%c coord.service %c createHullPolygon()', this.debugPrimary, this.debugSecondary, points, result ); }


    if ( !returnCartesian ) {
      return result;  
    }

    return this.toCartesians ( result );
/*
    let ret = [];
    result.forEach ( c => {
      // console.log ( '@@', c );
      ret.push ( this.toCartesian(c) );
    });
    return ret; */
  }

  findGeocenter ( coords: CoordGeodetic[] ) {

    if ( ! coords ) {
      return ;
    }

    /* Transform your dataset to the format expected by the library */
    var dataset = [];

    for(var i=0; i<coords.length; i++){
      dataset.push([coords[i].long, coords[i].lat]);
    }

    var dbscan = new clustering.DBSCAN();
    /* parameters: 
        20 - neighborhood radius
        5 - number of points in neighborhood to form a cluster
    */
    var clusters = dbscan.run(dataset, 20, 5);

    if(clusters.length > 0){

        /* Find the biggest cluster */
        var biggestCluster = clusters[0];

        for(i=1;i<clusters.length;i++){

            if(clusters[i].length > biggestCluster.length){
                biggestCluster = clusters[i];    
            }
        }

        /* The output of the library contains the indexes of the points in the cluster, not the coordinates, so we need to get the point from the dataset */
        var clusterPoints = [];
        var sumx = 0;
        var sumy = 0;

        for(i=0;i<biggestCluster.length;i++){
          var point = dataset[biggestCluster[i]];
          clusterPoints.push(point);

          /* It's also a good opportunity to cumulate x and y so we can get the average */
          sumx+=point[0];
          sumy+=point[1];
        }

        let ret = new CoordGeodetic({ long: sumx/clusterPoints.length, lat: sumy / clusterPoints.length });

        console.log('Cluster:', clusterPoints);    
        console.log('Center:', sumx/clusterPoints.length, sumy / clusterPoints.length);

        return ret;
    }
    else{
        console.log('No clusters');
    }
  }

  positionProfile ( scene:any, name:string, cartesian:any, manipulations:any = null ) {

    let ret = {
      name: name,
      height: null,
      globeHeight: null,
      cartographic: null,
      groundCartographic: null,
      groundCartesian: null,
      radian: null,
      screen: null,
      cartesian: null,
      cartesianIncoming: null,
      pickedHeight: null,
      pickedPosition: null,
      pickedPositionCartographic: null,
      manipulations: manipulations,
      ray: null,
      sample: null, 
      sampleEx: null,
      measureHelper: null,
      ex: null
    };
    ret.cartesianIncoming = cartesian;
    ret.cartographic = this.worldFromCartesian( cartesian );

    // all manipulations are in meters, except 'longitude' and 'latitude' which are in Cartographic::degrees (world coordinates)
    // lat/long offsets calculated using; https://stackoverflow.com/questions/7477003/calculating-new-longitude-latitude-from-old-n-meters

    if ( manipulations ) {

      // approx radius of the earth
      const EARTH = 6371000; // 6378137;

      if ( manipulations.hasOwnProperty('height') ) {
        ret.cartographic.height = manipulations.height;
        ret.manipulations.heightValue = manipulations.height;
      }
      if ( manipulations.hasOwnProperty('offsetLatitude') ) {
        const offset = (manipulations.offsetLatitude / EARTH) * (180 / Math.PI);
        ret.cartographic.latitude = ret.cartographic.latitude + offset;
        ret.manipulations.latitudeOffset = offset;
      }
      if ( manipulations.hasOwnProperty('offsetLongitude') ) {
        const offset = (manipulations.offsetLongitude / EARTH) * (180 / Math.PI) / Math.cos(ret.cartographic.latitude * Math.PI/180);
        ret.cartographic.longitude = ret.cartographic.longitude + offset;
        ret.manipulations.longitudeOffset = offset;
      }
      if ( manipulations.hasOwnProperty('offsetHeight') ) {
        ret.cartographic.height = ret.cartographic.height + manipulations.offsetHeight;
        ret.manipulations.heightOffset = manipulations.offsetHeight;
      }
    }
    ret.height = ret.cartographic.height;

    ret.screen = scene.cartesianToCanvasCoordinates(cartesian); // Cesium.SceneTransforms.wgs84ToWindowCoordinates( scene, ret.cartographic );

    ret.radian = this.worldToRadians ( ret.cartographic );

    ret.cartesian = new Cesium.Cartographic.toCartesian( ret.radian );

    // if there's a screen position for this position, sample it
    if ( ret.screen ) {

      // use the more advanced checkMousePosition() function for matrixed and filtered picking
      let measureHelper = this.measureHelper.checkMousePosition({ endPosition:ret.screen, forceFullResolution:true });

      // if it found a position through advanced means...
      if ( measureHelper && measureHelper.currentCoord && measureHelper.currentCoord.positionCart ) {
        ret.pickedPosition = measureHelper.currentCoord.positionCart;
      } else {
        // if not, try the simplest form of picking a position
        ret.pickedPosition = scene.pickPosition (ret.screen);
      }

      // convert to more readable formats
      ret.pickedPositionCartographic = this.worldFromCartesian( ret.pickedPosition );
      if ( ret.pickedPositionCartographic ) { ret.pickedHeight = ret.pickedPositionCartographic.height; }
    }

    // generic height sampling
    ret.globeHeight = scene.globe.getHeight(ret.radian);

    ret.groundCartographic = this.worldFromCartesian( ret.cartesian );
    ret.groundCartographic.height = -1;

    ret.groundCartesian = new Cesium.Cartographic.toCartesian( this.worldToRadians ( ret.groundCartographic ) );
    ret.ray = new Cesium.Ray( cartesian, ret.groundCartesian );

    ret.sample = scene.sampleHeight(ret.radian, [] );
    if ( manipulations && manipulations.hasOwnProperty('ex') ) {
      ret.sampleEx = scene.sampleHeight(ret.radian, manipulations.ex );
    }
    
    // ret.samplePick = scene.pickFromRay( ret.ray, ret.ex );

    // console.log ( '!!!', ret.cartographic, scene.cartesianToCanvasCoordinates(cartesian) );

    return ret;
  }

  heightProfileAnalysis( positions:any[], config:any = {} ) {

    // let provider = null;
    let samplingMethod = 'ellipsis';

    // if ( config.provider ) {
    //   provider = config.provider;
    //   samplingMethod = 'terrain';
    // }

    // console.log("@@@@@@HEIGHT_PROFILER START", positions, config );

    if ( !positions['length'] || positions.length < 2 ) {
      return "Not enough points";
    }

    let p1 = null;

    // Check if the terrain exists
    // var availability = provider.availability;
    // if (!Cesium.defined(availability)) {
    //     return "Cannot be calculated without an available provider";
    // }

    let profile = {
      positions: positions,
      coords: [],
      arrXAxis: [], // X axis data
      arrYAxis: [], // Y axis data
      maxElevation: -12000, // Maximum elevation value, int
      minElevation: 9000, // minimum elevation value, int
      xMin:9999,
      xMax:-9999,
      yMin:9999,
      yMax:-9999,
      samplingRate: { min:1, value:2, max:3 }, // meters
      samplingPoints: null, // No elevation sampling point set after interpolation, C3, []
      samplingPointsLine: null,
      samplingCompleted: false,
      renderPoints: [], // Renderable point after elevation processing, C3, []
      totalDistance: 0,
      totalSamplingPoints: 0
    };

    p1 = null;

    // calculate total distance
    positions.forEach ( p2 => {
      if ( p1 ) {
        profile.totalDistance = profile.totalDistance + this.properDistance ( p1, p2 );
      }
      p1 = p2;
    });

    // calculate a fitting sampling rate
    profile.samplingRate = this.calcSamplingDistance(profile.totalDistance);

    if ( config.samplingRate ) {
      profile.samplingRate.value = config.samplingRate;
    }
    
    p1 = null;
    let distance = 0;

    let bb = 0;
    let cc = 0;
    let dd = 0;

    let first = positions[0];

    // trying a better reset
    profile.samplingPoints = [];
    profile.samplingPointsLine = [];

    const sampleRate = profile.samplingRate.value / 10; // profile.totalDistance / (positions.length - 1);
    const totalFactor = profile.totalDistance / sampleRate;

    // console.log("@@@@@@HEIGHT_PROFILER INIT", profile.totalDistance, sampleRate, totalFactor );

    // calculate sample points per line
    positions.forEach ( p2 => {

      dd = 0;

      if ( p1 ) {

        const dist = this.properDistance ( p1, p2 );
        const samples = dist / sampleRate;
        // const howManySamples = dist * samples;

        if ( !profile.samplingPointsLine[bb] ) {
          profile.samplingPointsLine[bb] = { dist:dist, distToFirst: this.properDistance ( first, p2 ), idx:bb, items:[], accurateItems:[] };
        }

        // console.log("@@@@@@HEIGHT_PROFILER LINE", profile.samplingPointsLine[bb], samples );

        for (var i = 0; i < samples; ++i ) {

            var factor = i==0 ? 0 : i / samples;

            // console.log("@@@@@@HEIGHT_PROFILER ---", cc, dd, i, factor );

            // lerp method uses the provided Cartesian coordinates to calculate linear interpolation or extrapolation at factor
            var cartesian = Cesium.Cartesian3.lerp(p1, p2, factor, new Cesium.Cartesian3());
            profile.samplingPoints.push(cartesian);
            profile.samplingPointsLine[bb].items.push(cartesian);

            cc++;
            dd++;

            // distance = this.properDistance(profile.samplingPoints[i - 1], cartesian);
            // Set the position on the horizontal axis for each interpolation point
            // profile.arrXAxis.push(profile.arrXAxis[i - 1] + distance);
        }

        // distance = this.properDistance(profile.samplingPoints[i - 1], p2);
        // profile.arrXAxis.push(profile.arrXAxis[i - 1] + distance);
        // profile.samplingPoints.push(p2);

      }

      bb++;

      // profile.samplingPoints.push(p2);

      p1 = p2;
    });

    profile.totalSamplingPoints = profile.samplingPoints.length;

    let prev = 0;
    for (var i = 0; i < profile.totalSamplingPoints; i++) {

      var point = profile.samplingPoints[i];
      distance = i ? this.properDistance(profile.samplingPoints[i - 1], point) : 0;

      // Set the position on the horizontal axis for each interpolation point
      profile.arrXAxis.push( prev + distance );

      profile.coords.push(Cesium.Cartographic.fromCartesian(point)); // Go to the WGS84 coordinate system

      prev = profile.arrXAxis[i];
    }
    
    // console.log("@@@@@@HEIGHT_PROFILER CALC", cc, profile.totalSamplingPoints, profile );

    return profile;
  /*
    // define some temporary variables
    var actualSamplingPoints = 30; // The number of sampling points is too large and time-consuming and unnecessary, too small to reflect the topographical fluctuations, you can actually calculate it yourself, we just write 100
    // var startPoint = start; // startPoint requires C3
    // var endPoint= end; // endPoint requires C3
      
      // Perform linear interpolation calculation based on the starting point (the difference point has no actual elevation, only the position on the Cartesian coordinate system)
      profile.arrXAxis.push(0); // Start preparing the X axis
      profile.samplingPoints.push(startPoint);
      var distance = 0;
      for (var i = 1; i < actualSamplingPoints; i++) {
          var factor = i / actualSamplingPoints;
          // lerp method uses the provided Cartesian coordinates to calculate linear interpolation or extrapolation at factor
          var cartesian = Cesium.Cartesian3.lerp(startPoint, endPoint, factor, new Cesium.Cartesian3());
          profile.samplingPoints.push(cartesian);
          distance = this.calcTwoPointDistanceByEllipsoidGeodesic(profile.samplingPoints[i - 1], cartesian);
          // Set the position on the horizontal axis for each interpolation point
          profile.arrXAxis.push(profile.arrXAxis[i - 1] + distance);
      }
      distance = this.calcTwoPointDistanceByEllipsoidGeodesic(profile.samplingPoints[i - 1], endPoint);
      profile.arrXAxis.push(profile.arrXAxis[i - 1] + distance);
      profile.samplingPoints.push(endPoint);
      
      // Calculate the actual elevation of each point according to the starting point and the difference point
      var positions = [];
      for (var i = 0; i < profile.samplingPoints.length; i++) {
          var element = profile.samplingPoints[i];
          positions.push(Cesium.Cartographic.fromCartesian(element)); // Go to the WGS84 coordinate system
      }
  
      // console.log ( '%c LAYERS %c analysis()', this.debugPrimary, Constants._red, profile, positions, distance );
  
      // The sampleTerrainMostDetailed method initiates a sampleTerrain() request at the maximum available tile level of the terrain dataset
      var promise = Cesium.sampleTerrainMostDetailed(provider, positions); // Asynchronous process
  
      // console.log ( '%c LAYERS %c analysis() PROMISE', this.debugPrimary, Constants._red, promise );
  
      // promise.then ( check => {
      //   console.log ( '%c LAYERS %c analysis() PROMISE CHECK', this.debugPrimary, Constants._red, check );
      // });
  
      // It is used for external trigger after the asynchronous end. After the resolve is triggered, the calculation is completed, and the ECharts display is performed according to the calculated data
      var deferred = Cesium.when.defer();
      Cesium.when(promise, function(updatedPositions) {
        // console.log ( '%c LAYERS %c analysis() PROMISE WHEN', me.debugPrimary, Constants._red, updatedPositions );
          var min = 9000;
          var max = -12000;
          for (var kk = 0; kk < updatedPositions.length; kk++) {
              var element = updatedPositions[kk];
              var cartesian = me.mapService.viewer.scene.globe.ellipsoid.cartographicToCartesian(element);
              profile.renderPoints.push(cartesian);
              var tempCarto = Cesium.Cartographic.fromCartesian(cartesian);
              profile.arrYAxis.push(parseFloat(tempCarto.height.toFixed(4))); // prepare Y axis
              // Get the maximum and minimum elevation
              if (tempCarto.height < min) {
                  min = tempCarto.height;
              }
              if (tempCarto.height > max) {
                  max = tempCarto.height;
              }
          }
          profile.minElevation = min;
          profile.maxElevation = max;
  
          // console.log ( '%c LAYERS %c analysis() DONE', me.debugPrimary, Constants._red, profile );
  
          deferred.resolve(profile);
      });
      return deferred.promise;
      */
  }

  

  calcMidpoint ( p1:any, p2:any ) {
    // Compute vector from p1 to p2
    var p1p2 = new Cesium.Cartesian3(0.0, 0.0, 0.0);
    Cesium.Cartesian3.subtract(p2, p1, p1p2);

    // Compute vector to midpoint
    var halfp1p2 = new Cesium.Cartesian3(0.0, 0.0, 0.0);
    Cesium.Cartesian3.multiplyByScalar(p1p2, 0.5, halfp1p2);

    // Compute point half way between p1 and p2
    var p3 = new Cesium.Cartesian3(0.0, 0.0, 0.0);
    p3 = Cesium.Cartesian3.add(p1, halfp1p2, p3);
    return p3;
  }

  properDistance(startPoint, endPoint) {
    // Calculate the distance between two points on the ground using a terrain-free ellipsoid
    var geodesic = new Cesium.EllipsoidGeodesic();
    var start = Cesium.Cartographic.fromCartesian(startPoint);
    var end = Cesium.Cartographic.fromCartesian(endPoint);
    geodesic.setEndPoints(start, end);
    var s = geodesic.surfaceDistance;
    s = Math.sqrt(Math.pow(s, 2) + Math.pow(end.height - start.height, 2));
    s = s.toFixed(2);
    return parseFloat(s);
  };

  calcSamplingDistance ( length:number = 10 ) {
    if ( length < 6 ) {
      return { min: 0.01, value: 0.4, max: 2 };
    }
    if ( length < 15 ) {
      return { min: 0.05, value: 0.8, max: 3 };
    }
    if ( length < 30 ) {
      return { min: 0.2, value: 1.5, max: 5 };
    }
    if ( length < 100 ) {
      return { min: 0.2, value: 2, max: 6 };
    }
    if ( length < 200 ) {
      return { min: 0.6, value: 4, max: 10 };
    }
    if ( length < 400 ) {
      return { min: 2, value: 8, max: 20 };
    }
    if ( length < 800 ) {
      return { min: 3, value: 16, max: 30 };

    }
    return { min: 8, value: 20, max: 50 };
  }

}


// refactored to work with long,lat instead of x,y

namespace convexhull {
	
	// Returns a new array of points representing the convex hull of
	// the given set of points. The convex hull excludes collinear points.
  // This algorithm runs in O(n log n) time.
  
	export function makeHull(points: Array<CoordGeodetic>): Array<CoordGeodetic> {
		let newPoints = points.slice();
		newPoints.sort(convexhull.POINT_COMPARATOR);
		return convexhull.makeHullPresorted(newPoints);
	}

  export function makeHullCartesian3(points:any[] ): any[] {
		let newPoints = points.slice();
		newPoints.sort(convexhull.CART_COMPARATOR);
    newPoints = newPoints.filter ( p => p.x !== 0 && p.y !== 0 && p.z !== 0 );
		return convexhull.makeHullPresortedCartesian3(newPoints);
	}
	
	// Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
	export function makeHullPresorted(points: Array<CoordGeodetic>): Array<CoordGeodetic> {
		if (points.length <= 1)
			return points.slice();
		
		// Andrew's monotone chain algorithm. Positive y coordinates correspond to "up"
		// as per the mathematical convention, instead of "down" as per the computer
		// graphics convention. This doesn't affect the correctness of the result.
		
		let upperHull: Array<CoordGeodetic> = [];
		for (let i = 0; i < points.length; i++) {
			const p: CoordGeodetic = points[i];
			while (upperHull.length >= 2) {
				const q: CoordGeodetic = upperHull[upperHull.length - 1];
				const r: CoordGeodetic = upperHull[upperHull.length - 2];
				if ((q.long - r.long) * (p.lat - r.lat) >= (q.lat - r.lat) * (p.long - r.long))
					upperHull.pop();
				else
					break;
			}
			upperHull.push(p);
		}
		upperHull.pop();
		
		let lowerHull: Array<CoordGeodetic> = [];
		for (let i = points.length - 1; i >= 0; i--) {
			const p: CoordGeodetic = points[i];
			while (lowerHull.length >= 2) {
				const q: CoordGeodetic = lowerHull[lowerHull.length - 1];
				const r: CoordGeodetic = lowerHull[lowerHull.length - 2];
				if ((q.long - r.long) * (p.lat - r.lat) >= (q.lat - r.lat) * (p.long - r.long))
					lowerHull.pop();
				else
					break;
			}
			lowerHull.push(p);
		}
		lowerHull.pop();
		
		if (upperHull.length == 1 && lowerHull.length == 1 && upperHull[0].long == lowerHull[0].long && upperHull[0].lat == lowerHull[0].lat)
			return upperHull;
		else
			return upperHull.concat(lowerHull);
	}
	
	// Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
	export function makeHullPresortedCartesian3(points:any[]): any[] {
		if (points.length <= 1)
			return points.slice();
		
		// Andrew's monotone chain algorithm. Positive y coordinates correspond to "up"
		// as per the mathematical convention, instead of "down" as per the computer
		// graphics convention. This doesn't affect the correctness of the result.
		
		let upperHull:any[] = [];
		for (let i = 0; i < points.length; i++) {
			const p = points[i];
			while (upperHull.length >= 2) {
				const q = upperHull[upperHull.length - 1];
				const r = upperHull[upperHull.length - 2];
				if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x))
					upperHull.pop();
				else
					break;
			}
			upperHull.push(p);
		}
		upperHull.pop();
		
		let lowerHull:any[] = [];
		for (let i = points.length - 1; i >= 0; i--) {
			const p = points[i];
			while (lowerHull.length >= 2) {
				const q = lowerHull[lowerHull.length - 1];
				const r = lowerHull[lowerHull.length - 2];
				if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x))
					lowerHull.pop();
				else
					break;
			}
			lowerHull.push(p);
		}
		lowerHull.pop();
		
		if (upperHull.length == 1 && lowerHull.length == 1 && upperHull[0].x == lowerHull[0].x && upperHull[0].y == lowerHull[0].y)
			return upperHull;
		else
			return upperHull.concat(lowerHull);
	}

	export function POINT_COMPARATOR(a: CoordGeodetic, b: CoordGeodetic): number {
		if (a.long < b.long)
			return -1;
		else if (a.long > b.long)
			return +1;
		else if (a.lat < b.lat)
			return -1;
		else if (a.lat > b.lat)
			return +1;
		else
			return 0;
	}

  export function CART_COMPARATOR(a:any, b:any): number {
		if (a.x < b.x)
			return -1;
		else if (a.x > b.x)
			return +1;
		else if (a.y < b.y)
			return -1;
		else if (a.y > b.y)
			return +1;
		else
			return 0;
	}
	
}